module.exports = __webpack_public_path__ + "img/marsya.6e618a48.jpg";